import { useSelector } from 'react-redux';
import { useTranslation } from 'next-i18next';
import i18n from '../../../../i18n'; // eslint-disable-line
import { useEffect, useState } from 'react';
import useFormUpdate from 'components/impfschaeden/assistent/hooks/useFormUpdate.js';
import { Benutzerinformation } from './components/Benutzerinformation.js';
import { Container, Row, Form } from 'components/ui';
import styled from 'styled-components';
import mapValues from 'lodash/mapValues';

const FormStyle = styled(Form)`
	width: '100%';
	align-items: 'center';
`;

const Step02 = () => {
	const vaxFormData = useSelector((state) => state.vaxFormData);
	const { updateUser } = useFormUpdate('vaxStep2');
	const [t] = useTranslation(['translation']);

	const validation = useSelector((state) => state.formValidation.vaxStep2);
	const user = useSelector((state) => state.settings.currentUser);
	const language = useSelector((state) => state.settings.language);
	const [translatedValidation, setTranslatedValidation] = useState({});

	useEffect(() => {
		if (!validation) {
			return;
		}
		setTranslatedValidation(
			mapValues(validation, (value) => {
				return t('validation.' + value);
			})
		);
	}, [validation, user, language]);

	return (
		<>
			<form
				className={FormStyle}
				onSubmit={(e) => {
					e.preventDefault();
				}}
			>
				<Container spacing={4}>
					<Row xs={12} style={{ marginTop: '0px' }}>
						<Benutzerinformation
							anotherPerson={vaxFormData.anotherPerson}
							updateUser={updateUser}
							validation={translatedValidation}
							formData={vaxFormData}
							hideCreateAccount={!!user}
							integratedTitle={t('impfschaeden.erfassen.ihre_kontaktdaten')}
						/>
					</Row>
				</Container>
			</form>
		</>
	);
};

export default Step02;
